import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { isFedrampModerate } from '@atlaskit/atlassian-context/is-fedramp-moderate';

/**
 * Detects FedRamp Moderate perimeter using the appropriate method for browser vs server context.
 *
 * • `isFedRamp()` works in browser but fails in Tesseract (no location, wrong globals)
 * • `isFedrampModerate()` works on server but is narrower in browser (cookie-only, misses hostnames)
 * • Browser uses `isFedRamp()` to maintain existing behavior for all callers
 * • Server uses `isFedrampModerate()` since `isFedRamp()` doesn't work in Tesseract
 * • Relies on `document` being undefined in server renders to choose the right method
 */
export function isFedRampInAnyContext(): boolean {
	// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
	return typeof document === 'undefined' ? isFedrampModerate() : isFedRamp();
}
